import { useTheme } from "@fluentui/react";
import React from "react";
import { Column } from "./Column";
import { Row } from "./Row";
export const Subtitle = (props) => {
    const theme = useTheme();
    const TEXT_STYLE = {
        color: theme.palette.black,
        fontSize: theme.fonts.mediumPlus.fontSize
    };
    return props.className ? React.createElement(Row, null,
        React.createElement(Column, { lg: 12, md: 12, sm: 12 },
            React.createElement("div", { style: { marginTop: '20px' } },
                React.createElement("h2", { className: props.className, style: TEXT_STYLE }, props.text)))) : React.createElement(Row, null,
        React.createElement(Column, { lg: 12, md: 12, sm: 12 },
            React.createElement("div", { style: { marginTop: '20px' } },
                React.createElement("h2", { style: TEXT_STYLE }, props.text))));
};
